import React, { useContext, useState } from "react";
import { API_SERVICE } from "api/service";
import { saveAs } from "file-saver";
import { CustomToast } from "components/elements/alert/custom-toast";
import { HELPER } from "utils/helper";
import moment from "moment";
import { MainContext } from "App";
import { Optional } from "components/elements/optional/optional";
import { DownloadProgress } from "components/elements/download-progress/download-progress";
import { BACK_OFFICE_API } from "../../../api/routes/back-office/index";

export function ConfirmationDialog(props) {
  const mainContext = useContext(MainContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function downloadReport() {
    setLoading(true);
    const payload = {
      ownerId: props?.selectedParticipant?.ownerId,
      detailId: props?.selectedParticipant.detailId,
    };
    let date = props?.selectedParticipant?.reportTime;
    if (date && date?.length === 7) {
      date.pop();
    }
    date = moment(date, "YYYY MM DD HH mm ss").format("YYYY-MM-DD");
    const url = BACK_OFFICE_API.PARTICIPANT_REPORT.DOWNLOAD_PARTICIPANT_REPORT;
    const isBlob = true;
    API_SERVICE.MAKE_GET_REQUEST(
      `${url}/${payload?.ownerId}/${payload?.detailId}`,
      isBlob,
      mainContext
    )
      .then((data) => {
        saveAs(
          data,
          `${props?.selectedParticipant?.ownerName}-settlement_report_at_${date}.xlsx`
        );
        props.closeModal();
      })
      .catch((error) => {
        handleError(error);
      });
  }

  async function handleError(error) {
    const errMessage = await HELPER.PARSE_BLOB_ERROR(error);
    setError(errMessage);
    setLoading(false);
  }

  const dialogView = () => {
    if (props.showSuccess) {
      return <div></div>;
    } else {
      return (
        <div>
          <h4 className="p-text-left p-mt-0">Confirm Download!</h4>
          <p className="p-text-left">{props.warningText}</p>
          <div className="p-pb-1">
            {error && (
              <CustomToast
                title="Error"
                description={error}
                type="error"
                clearToast={() => setError(null)}
              />
            )}
          </div>
          <Optional show={loading}>
            <DownloadProgress />
          </Optional>
          {/* {loading ? (
            <CustomLoader loadingText="Loading..." />
          ) : ( */}
          <Optional show={!loading}>
            <div className="p-mt-4 p-pb-2">
              <div className="p-grid">
                <div className="p-col-6">
                  <button
                    onClick={props.closeModal}
                    className="secondary-button"
                  >
                    Cancel
                  </button>
                </div>
                <div className="p-col-6">
                  <button onClick={downloadReport} className="primary-button">
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </Optional>
          {/* )} */}
        </div>
      );
    }
  };

  return dialogView();
}
